import React, { useEffect, useState } from 'react';
import logoImg from '@/assets/m/hkzs.png';
import logo2Img from '@/assets/m/hkzk.png';
import { useNavigate } from 'react-router-dom';
import androidImg from '@/assets/m/android.png';
import './index.css';

const DownloadPage = (props) => {
  useEffect(() => {
    document.title = '鸿凯瑞达-App列表页';
  }, []);
  const navigate = useNavigate();
  const gohkzsDownloadPage = () => {
    navigate('/m/downloadpage');
  };

  const gohkzkDownloadPage = () => {
    navigate('/m/hkzkdownloadpage');
  };

  return (
    <div className="page-all-select">
      <div className="dow-page-select">
        <div className="top-text">欢迎使用，</div>
        <div className="top-text" style={{ marginBottom: 40 }}>
          鸿凯瑞达智能产品
        </div>

        <div
          className="card-select"
          style={{ justifyContent: 'space-between' }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src={logoImg} alt="" className="logoimg-select" />

            <div style={{ marginLeft: 18 }}>
              <div className="logoname-select">鸿凯智锁</div>
              <div className="logotips">轻量化管理您的设备</div>
            </div>
          </div>

          <div className="download-btn" onClick={gohkzsDownloadPage}>
            去下载
          </div>
        </div>

        <div
          className="card-select"
          style={{ justifyContent: 'space-between' }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src={logo2Img} alt="" className="logoimg-select" />

            <div style={{ marginLeft: 18 }}>
              <div className="logoname-select">鸿凯智控</div>
              <div className="logotips">开启便捷智能生活</div>
            </div>
          </div>

          <div className="download-btn" onClick={gohkzkDownloadPage}>
            去下载
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadPage;
